<!-- Page Header End -->
<app-pageheader [pageOptions]="pageOptions"></app-pageheader>
<!-- Page Header End -->

<!-- Page content start -->
<div class="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
  <div class="container">
    <div class="row justify-content-center">
      <app-articles-view
        [articles]="PARTNERS_DATA"
        [itemsPerPage]="limit"
        [totalcount] ="totalcount"
        (onPaginateEvent) = "onPaginateEvent($event)"
      ></app-articles-view>
    </div>
  </div>
</div>
<!-- Page content end -->
